import { useContext, useLayoutEffect, useRef, Fragment } from 'react';
import { Button, CircularProgress, Grid } from '@mui/material';
import { AssistantMessage, UserMessage } from './ChatMessage';
import { AssistantLoader, ConversationSkeleton } from './Loader';
import { useTheme } from "@mui/material/styles";
import { WizardContext } from '../wizard/Context';
import { useInfiniteQuery } from 'react-query';
import { getChat } from '../../services/Chat';
import Home from './Home';

const ChatConversationLayout = ({ isFullScreen, userDetails, isLoading }) => {
  const { state } = useContext(WizardContext);
  const { chatConfig } = state;
  const chatBodyRef = useRef(null);
  const theme = useTheme();
  const { data, isLoading: dataLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery(
    ["getChatById", chatConfig?.chatId || "0"],
    getChat,
    {
      getNextPageParam: (lastPage) => lastPage?.lastEvaluatedKey ?? undefined,
      enabled: !chatConfig?.initiated,
      refetchOnWindowFocus: false,
    }
  );

  const activePage = data?.pages?.[0];

  useLayoutEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [activePage]);

  const ReadMore = () => {
    return (
      <Grid
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {isFetchingNextPage ? <CircularProgress size={24} /> :
          <Button
            onClick={fetchNextPage}
          >
            Read more
          </Button>}
      </Grid>
    );
  }

  const Conversation = ({ data, userDetails }) => {
    return (
      <>
        {data?.pages?.slice().reverse().map((page, pageIndex) => (
          <Fragment key={pageIndex}>
            {page?.conversations?.map((message, index) => (
              message?.role === 'assistant' ? (
                <AssistantMessage key={`${pageIndex}-${index}`} message={message} />
              ) : (
                <UserMessage key={`${pageIndex}-${index}`} message={message} userName={userDetails?.userName} />
              )
            ))}
          </Fragment>
        ))}
      </>
    );
  }

  return (
    <Grid
      sx={{
        width: '100%',
        display: 'flex',
        paddingX: isFullScreen ? '10vw' : '25px',
        flexDirection: 'column',
        scrollbarColor: `${theme.palette.primary[800]} #EAE8E8`,
        height: isFullScreen ? 'calc(100vh - 215px)' : '60vh',
        overflowY: 'auto',
        scrollBehavior: 'smooth',
        scrollbarWidth: 'thin',
        flexWrap: 'nowrap',
      }}
      ref={chatBodyRef}
      container
    >
      {hasNextPage && <ReadMore />}

      {!data && !dataLoading && <Home />}

      {dataLoading && <ConversationSkeleton items={4} />}

      <Conversation data={data} userDetails={userDetails} />

      {isLoading && <AssistantLoader />}

    </Grid>
  );
}

export default ChatConversationLayout;